import type { RouteRecordRaw } from 'vue-router';
import { PRICING_ROUTE_NAME } from './consts';

export const pricingRoutes: RouteRecordRaw = {
  path: '/pricing',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true },
  children: [
    {
      name: PRICING_ROUTE_NAME.PRICING,
      path: '',
      component: () => import('./Pricing.vue'),
    },
  ],
};
